import { RQAPICallWithData } from 'store/APIClient';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { createBudgetQueryKeys } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';
import { useBudgetProposalsQuery } from 'routes/BudgetModule/helpers/hooks/useCustomQuery';

export const useGetBudgetProposals = () => {
    const { budgetProposalsKeys } = createBudgetQueryKeys();
    return useBudgetProposalsQuery(budgetProposalsKeys(), async () => {
        const response = await RQAPICallWithData<BudgetProposalT[]>({
            endpoint: 'budget_proposals',
            method: 'GET',
        });
        return response.content.data;
    });
};
